<template>
  <v-dialog :model-value="show" persistent max-width="540">
    <v-card>
      <v-card-title class="text-h6 d-flex align-center">
        <v-icon class="mr-2" color="primary">mdi-tune-variant</v-icon>
        Configura tu bodega
      </v-card-title>
      <v-card-text>
        <p class="text-body-2 mb-4">
          Responde 3 preguntas para adaptar el sistema a tu operación. Podrás
          cambiarlo después desde el panel lateral.
        </p>

        <v-card variant="outlined" class="pa-3 mb-3">
          <v-switch
            v-model="manejaPrecios"
            color="primary"
            hide-details
            label="¿Manejas precios de venta? (facturas / valorizas las salidas)"
          />
          <div class="text-caption text-grey ml-2">
            Habilita órdenes de venta, gestión de costos e indicadores valorizados.
          </div>
        </v-card>

        <v-card variant="outlined" class="pa-3 mb-3">
          <v-switch
            v-model="pickingConOperarios"
            color="primary"
            hide-details
            label="¿Tienes operarios de bodega dedicados?"
          />
          <div class="text-caption text-grey ml-2">
            Habilita picking inteligente y asignación de tareas. Si no, la salida
            es un egreso directo.
          </div>
        </v-card>

        <v-card variant="outlined" class="pa-3 mb-3">
          <v-switch
            v-model="sectorSalud"
            color="primary"
            hide-details
            label="¿Eres una institución de salud? (hospital, clínica, centro médico)"
          />
          <div class="text-caption text-grey ml-2">
            Activa la trazabilidad de dispositivos médicos según las Normas
            Técnicas 226 y 247 del MINSAL, las salidas hacia servicios clínicos y
            el vocabulario hospitalario. Oculta la venta a clientes.
          </div>
        </v-card>

        <v-alert type="info" variant="tonal" density="compact">
          Perfil sugerido: <strong>{{ perfilSugerido }}</strong>
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" variant="elevated" @click="finish">
          Comenzar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OnboardingEdition',
  data() {
    return {
      manejaPrecios: false,
      pickingConOperarios: false,
      sectorSalud: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'currentUser']),
    ...mapGetters('edition', ['onboardingCompleto']),
    show() {
      // Solo para admin autenticado y con el onboarding pendiente
      return this.isAuthenticated &&
        this.currentUser?.role === 'admin' &&
        !this.onboardingCompleto
    },
    perfilSugerido() {
      if (this.sectorSalud) return 'Institución de salud (trazabilidad NT 226/247)'
      if (this.manejaPrecios && this.pickingConOperarios) return 'Empresa (con precios y operarios)'
      if (!this.manejaPrecios && !this.pickingConOperarios) return 'Pyme básica (egreso directo)'
      if (this.manejaPrecios && !this.pickingConOperarios) return 'Pyme que factura (egreso con precios)'
      return 'Empresa operativa (operarios, sin precios)'
    }
  },
  methods: {
    finish() {
      this.$store.dispatch('edition/completeOnboarding', {
        manejaPrecios: this.manejaPrecios,
        pickingConOperarios: this.pickingConOperarios,
        sectorSalud: this.sectorSalud
      })
    }
  }
}
</script>
